import Suspense from "./suspense";

export default Suspense;